import { useEffect, useState } from "react";

import { DOWNLOADABLE_FILE_CATEGORIES } from "../constants";
import { fetchUploadFiles } from "../services/backendRequests";
import moment from "moment";

const useDownloadFiles = (statistics, uploadSession, user) => {
  const downloadableStats = statistics.filter((s) =>
    DOWNLOADABLE_FILE_CATEGORIES.includes(s.category)
  );

  const [selectedCategory, setSelectedCategory] = useState("");
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [checkedIds, setCheckedIds] = useState({});
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    if (!selectedCategory) {
      setFiles([]);
      return;
    }
    setLoading(true);
    setCheckedIds({});
    setDownloading(false);
    fetchUploadFiles(uploadSession.id, selectedCategory, user)
      .then((data) =>
        // Show the most recently updated files first. Parse with moment (same
        // as the display) so non-ISO date strings still sort correctly.
        setFiles(
          (Array.isArray(data) ? [...data] : []).sort(
            (a, b) =>
              moment(b.updated_at).valueOf() - moment(a.updated_at).valueOf()
          )
        )
      )
      .catch((err) => {
        console.error("Failed to fetch upload files:", err);
        setFiles([]);
      })
      .finally(() => setLoading(false));
  }, [selectedCategory]);

  // Takes the category itself: the picker is a react-select, not a <select>.
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  const handleToggle = (fileId) => {
    setCheckedIds((prev) => ({ ...prev, [fileId]: !prev[fileId] }));
  };

  const handleCheckAll = () => {
    const allChecked = files.every((f) => checkedIds[f.id]);
    if (allChecked) {
      setCheckedIds({});
    } else {
      const all = {};
      files.forEach((f) => {
        all[f.id] = true;
      });
      setCheckedIds(all);
    }
  };

  const checkedFiles = files.filter((f) => checkedIds[f.id]);
  const allChecked = files.length > 0 && files.every((f) => checkedIds[f.id]);
  const someChecked = checkedFiles.length > 0 && !allChecked;
  const hasSelection = checkedFiles.length > 0;

  const handleDownloadSelection = () => {
    if (checkedFiles.length === 0) return;
    setDownloading(true);
    checkedFiles.forEach((file, i) => {
      setTimeout(() => {
        const a = document.createElement("a");
        a.href = file.download_url;
        a.download = file.filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }, i * 200);
    });
    setTimeout(() => setDownloading(false), checkedFiles.length * 200 + 500);
  };

  return {
    downloadableStats,
    selectedCategory,
    files,
    loading,
    checkedIds,
    downloading,
    checkedFiles,
    allChecked,
    someChecked,
    hasSelection,
    handleCategoryChange,
    handleToggle,
    handleCheckAll,
    handleDownloadSelection,
  };
};

export default useDownloadFiles;
